import React, { createContext, useState, useContext, useEffect } from 'react';

const GameContext = createContext();

export const GameProvider = ({ children }) => {

    //game state
    const defaultGameState = {
        grandJackpot: 1000000,
        majorJackpot: 10000,
        minorBonus: 1000,
        miniBonus: 100,

        bets: [1,2,5,10,15,20,50,100,500,1000,2500,5000,10000],
        currentBet: 10,

        currentBalance: 200,
    };

    
    const [gameState, setGameState] = useState(() => {
        const storedState = localStorage.getItem('gameState');
        return storedState ? JSON.parse(storedState) : defaultGameState;
    });

    useEffect(() => {
        localStorage.setItem('gameState', JSON.stringify(gameState));
    }, [gameState]);
    


    //get state
    const getState = (key) => gameState[key];
    //update state
    const updateState = (key, value) => {setGameState(prevState => ({ ...prevState, [key]: value }));};


    //jackpot incrementors
    useEffect(() => {
        const interval = setInterval(() => {
            setGameState(prevState => ({
                ...prevState,
                grandJackpot: prevState.grandJackpot + 0.94,
                majorJackpot: prevState.majorJackpot + 0.26,
            }));
        }, 300);
        return () => clearInterval(interval);
    }, []);


    //spin
    const [isSpinning, setIsSpinning] = useState(false);
    const startSpin = () => {
        setIsSpinning(true);
        updateState('currentBalance', gameState.currentBalance - gameState.currentBet);
        setWinAmount(0);
    };

    const stopSpin = () => {
        setIsSpinning(false);
    };


    //win
    const [winAmount, setWinAmount] = useState(0);
    const updateWinAmount = (winAmount) => {
        setWinAmount(winAmount);
        var currentBal = gameState.currentBalance;
        updateState('currentBalance', currentBal + winAmount);
    };


    return (
        <GameContext.Provider value={{ gameState, getState, updateState, startSpin, stopSpin, isSpinning, winAmount, updateWinAmount }}>
            {children}
        </GameContext.Provider>
    );
};

// Custom hook for easier consumption of context
export const useGameContext = () => useContext(GameContext);

export default GameContext;
